import React from 'react';
import InputTitleView from './InputTitleView';

const TextInputView = ({ title = '', required = false, subTitle = '', placeholder, isSmall = false, name, value, onChange }) => {
  return (
    <div className="recruitment-text-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className={`recruitment-text-input-view-input-wrapper ${isSmall && 'small'}`}>
        <input name={name} type="text" placeholder={placeholder} value={value} onChange={({ target }) => onChange({ name: target.name, value: target.value })} />
      </div>
    </div>
  );
};

export default TextInputView;
